import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_OVERVIEW_ENERGYLABEL: MijnRoute = {
    path: 'energielabel',
    navigationEvent: 'toHypotheekEnergylabel',
    regex: /^\/hypotheek\/energielabel$/,
    webcomponent: 'mijn-hypotheken-home-webcomponent',
    internalPath: '/energielabel'
};
